export interface Vehicle {
  brand?: string;
  licensePlate: string;
  model?: string;
}

export function vehicleToString(vehicle: Vehicle | undefined): string {
  if (!vehicle) {
    return "No car data";
  }

  return `${vehicle.brand} ${vehicle.model} - ${vehicle.licensePlate}`;
}
